module.exports = __webpack_public_path__ + "static/media/icon-4.729869d6.svg";